import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import EditText from "../EditText";
import FormInput from "core/FormInput";

const EditTextWithTextInput = ({
    defaultDisplayText,
    displayText,
    buttonAriaLabel,
    placeholderText,
    labelText,
    onNewTextSubmit,
    errorMessage,
    ...inputAttributes
}) => {
    const [inputValue, setInputValue] = useState(displayText || "");

    const prevText = useRef(0);
    useEffect(() => {
        if (displayText !== prevText.current) {
            setInputValue(displayText);
        }
        prevText.current = displayText;
    }, [displayText]);

    const handleNewTextSubmit = exitEditingMode => {
        typeof onNewTextSubmit === "function" &&
            onNewTextSubmit(inputValue, exitEditingMode);
    };

    const handleChange = value => {
        setInputValue(value);
    };

    return (
        <EditText
            defaultDisplayText={defaultDisplayText}
            displayText={displayText}
            buttonAriaLabel={buttonAriaLabel}
            editingMode={exitEditingMode => (
                <FormInput
                    placeholderText={placeholderText}
                    labelText={labelText}
                    value={inputValue}
                    onChange={value => handleChange(value)}
                    onBlur={() => handleNewTextSubmit(exitEditingMode)}
                    onKeyDown={e => {
                        if (e.key === "ArrowLeft" || e.key === "ArrowRight")
                            e.stopPropagation();
                        if (e.key !== "Enter") return;
                        handleNewTextSubmit(exitEditingMode);
                    }}
                    type="text"
                    errorMessageOverride={errorMessage}
                    {...inputAttributes}
                />
            )}
        />
    );
};

EditTextWithTextInput.propTypes = {
    defaultDisplayText: PropTypes.string.isRequired,
    displayText: PropTypes.string,
    buttonAriaLabel: PropTypes.string,
    placeholderText: PropTypes.string.isRequired,
    labelText: PropTypes.string.isRequired,
    onNewTextSubmit: PropTypes.func,
    errorMessage: PropTypes.string
};

export default EditTextWithTextInput;
